import { NavLink, Link } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { TID } from "@/lib/testIds";
import {
  LogOut,
  LayoutGrid,
  Sparkles,
  Users,
  Bot,
  Network,
  Gavel,
  FileText,
  Receipt,
  Plug,
  Settings as SettingsIcon,
} from "lucide-react";

const MODULES = [
  { key: "dashboard", to: "/app", label: "Dashboard", icon: LayoutGrid, testId: TID.navDashboard, end: true },
  { key: "leads", to: "/app/leads", label: "Lead / Preventivo / PRD", icon: Sparkles, testId: TID.navLeads },
  { key: "clients", to: "/app/clients", label: "Clienti / Progetti", icon: Users, testId: TID.navClients },
  { key: "agents", to: "/app/agents", label: "Agenti / Flussi", icon: Bot, testId: TID.navAgents },
  { key: "memograph", to: "/app/memograph", label: "Memoria (Memograph)", icon: Network, testId: TID.navMemograph },
  { key: "governance", to: "/app/governance", label: "Governance / Stato", icon: Gavel, testId: TID.navGovernance },
];

const SUB_MODULES = [
  { to: "/app/quotes", label: "Preventivi", icon: Receipt, testId: TID.navQuotes },
  { to: "/app/prds", label: "PRD", icon: FileText, testId: TID.navPrds },
];

const SYSTEM_MODULES = [
  { to: "/app/integrations", label: "Integrazioni", icon: Plug, testId: TID.navIntegrations },
  { to: "/app/settings", label: "Impostazioni", icon: SettingsIcon, testId: TID.navSettings },
];

export default function Sidebar() {
  const { session, logout } = useAuth();

  return (
    <aside
      data-testid={TID.sidebar}
      className="w-64 shrink-0 border-r border-[#1F1F1F] bg-[#050505] flex flex-col sticky top-0 h-screen"
    >
      <div className="border-b border-[#1F1F1F] px-5 py-5">
        <Link to="/app" className="block">
          <div className="font-heading text-xl font-black tracking-tighter uppercase">
            STRUCTURA<span className="text-[#5C5C5C]">.</span>
          </div>
          <div className="font-mono text-[10px] tracking-[0.24em] uppercase text-neutral-500 mt-1">
            structura.org3.ai
          </div>
        </Link>
      </div>

      <nav className="flex-1 py-4 flex flex-col gap-0.5 overflow-y-auto">
        <div className="px-5 pb-2 font-mono text-[10px] tracking-[0.24em] uppercase text-neutral-600">
          Moduli
        </div>
        {MODULES.map(({ key, ...m }) => (
          <SidebarLink key={key} {...m} />
        ))}

        <div className="mt-4 px-5 pb-2 pt-2 font-mono text-[10px] tracking-[0.24em] uppercase text-neutral-600 border-t border-[#1F1F1F]">
          Artefatti
        </div>
        {SUB_MODULES.map(({ to, ...m }) => (
          <SidebarLink key={to} to={to} {...m} />
        ))}

        <div className="mt-4 px-5 pb-2 pt-2 font-mono text-[10px] tracking-[0.24em] uppercase text-neutral-600 border-t border-[#1F1F1F]">
          Sistema
        </div>
        {SYSTEM_MODULES.map(({ to, ...m }) => (
          <SidebarLink key={to} to={to} {...m} />
        ))}
      </nav>

      <div className="border-t border-[#1F1F1F] px-5 py-4">
        <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-neutral-600 mb-1">
          session
        </div>
        <div className="font-mono text-xs text-neutral-300 truncate mb-3" title={session?.email}>
          {session?.email}
        </div>
        <button
          data-testid={TID.sidebarLogout}
          onClick={logout}
          className="w-full border border-[#1F1F1F] hover:border-[#333] hover:bg-[#0C0C0C] px-3 py-2 flex items-center justify-between font-mono text-[11px] uppercase tracking-widest text-neutral-400 hover:text-[#EDEDED] transition-colors"
        >
          <span>Logout</span>
          <LogOut className="w-3.5 h-3.5" strokeWidth={1.5} />
        </button>
      </div>
    </aside>
  );
}

function SidebarLink({ to, icon: Icon, label, end, testId }) {
  return (
    <NavLink
      to={to}
      end={end}
      data-testid={testId}
      className={({ isActive }) =>
        [
          "px-5 py-2 flex items-center gap-3 border-l-2 text-sm",
          isActive
            ? "border-[#EDEDED] bg-[#0C0C0C] text-[#EDEDED]"
            : "border-transparent text-neutral-400 hover:text-[#EDEDED] hover:bg-[#0C0C0C]",
        ].join(" ")
      }
    >
      <Icon className="w-4 h-4" strokeWidth={1.5} />
      <span>{label}</span>
    </NavLink>
  );
}
